import React from 'react';
import _ from 'lodash';

import ResourcesPage from '../../js/pages/ResourcesPage';
import CMS from '../../../server/services/cms';

export default function Page(props) {
  return <ResourcesPage {...props} />;
}

export async function getServerSideProps() {
  // Fetch resource content
  const resources = await CMS.getResources();

  return {
    props: {
      resources: JSON.parse(JSON.stringify(resources)),
    },
  };
}
